import { Dashboard } from '../components/dashboard/Dashboard';

export const DashboardContainer = Dashboard;
